import api from 'app/shared/utils/api';
import appLogger from 'app/shared/loggers/appLogger';
import promise from 'promise';

const StaticMapActions = {
    signUrl(url, params) {
        return dispatch => dispatch(api.users.signUrl(url, params))
            .then((response) => {
                if (response.success === false) {
                    // error
                    return promise.reject({
                        message: `ERROR: Request to sign url @ ${url}`,
                    });
                }
                // success
                return response.signedUrl;
            })
            .catch(error => appLogger.logError({
                message: error.message,
                context: 'StaticMapActions.signUrl',
            }));
    },
};

export default StaticMapActions;
